import React from 'react';

import { cn } from '../../../../lib/css/className/className';
import { AlertLineSlideProps } from '../../types';
import { HStack, VStack } from '../../../Stack';
import { TextGenericWithSkin } from '../../../TextGeneric/TextGenericWithSkin';

import './AlertLineSlideMobile.css';

const cls = cn('AlertLineSlideMobile');

type AlertLineSlideMobileProps = Omit<AlertLineSlideProps, 'titleAddonLeft'>;

export const AlertLineSlideMobile = function AlertLineSlideMobile(props: AlertLineSlideMobileProps) {
    const { title, caption, actionIcon, buttonGroup, textAlign, isTitleTruncated } = props;

    return (
        <VStack gap="current-geometry" className={cls('')}>
            <VStack>
                <HStack justifyContent="space-between" gap="current-geometry">
                    <TextGenericWithSkin
                        skinSize="xs"
                        textSize="current-main"
                        bold
                        color="current"
                        textAlign={textAlign}
                        className={cls('title')}
                        isTruncated={isTitleTruncated}
                    >
                        {title}
                    </TextGenericWithSkin>
                    {actionIcon && (
                        <div data-testid="AlertLineSlideMobile.Action" className={cls('action')}>
                            {actionIcon}
                        </div>
                    )}
                </HStack>
                {caption && (
                    <TextGenericWithSkin
                        skinSize="xs"
                        textSize="current-body"
                        color="current"
                        role="supplementary"
                        textAlign={textAlign}
                    >
                        {caption}
                    </TextGenericWithSkin>
                )}
            </VStack>
            {buttonGroup && (
                <VStack gap="current-geometry" className={cls('button-group')}>
                    {buttonGroup}
                </VStack>
            )}
        </VStack>
    );
};
